import { motion } from "framer-motion";

const PageHeader = ({ chapter, title, intro }) => (
  <div className="px-6 md:px-12 pt-40 pb-16 max-w-[1500px] mx-auto">
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      className="font-mono text-[11px] uppercase tracking-[0.5em] text-[#8a8a8a] mb-8"
    >
      {chapter}
    </motion.p>
    <h1 className="font-serif font-light tracking-tight text-[#f2f0ec] text-6xl md:text-[10rem] leading-[0.82] overflow-hidden">
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
      >
        {title}
      </motion.span>
    </h1>
    {intro && (
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.8 }}
        className="mt-10 max-w-xl font-serif text-2xl leading-[1.4] text-[#d8d5ce]"
      >
        {intro}
      </motion.p>
    )}
  </div>
);

export default PageHeader;
